import * as React from 'react';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { IBusinessSignUpItem, IBusinessSignUpViewProps } from './bju-onboarding-form';

const BusinessSignUpItem: React.FC<IBusinessSignUpItem> = ({ wrapper, label, errorMessage, input, isAddressInput }) => {
    // Hide label and error message if rendering address section
    return (
        <Node {...wrapper}>
            {!isAddressInput && label}
            {!isAddressInput && errorMessage}
            {input}
        </Node>
    );
};

const BusinesSignUpView: React.FC<IBusinessSignUpViewProps> = props => {
    const { businessSignUp, ContainerWrapper, businessSignUpForm, heading, instructions } = props;

    const { FormWrapper, buttons, items, errorMessage, disclaimer } = businessSignUpForm;

    return (
        <Module {...businessSignUp}>
            <Node {...ContainerWrapper}>
                <div className="header-instructions-container">
                    {heading}
                    {instructions}
                </div>
                {/* Rest of the form */}
                <Node {...FormWrapper}>
                    {items &&
                        items.map((item: IBusinessSignUpItem) => {
                            return <BusinessSignUpItem key={item.id} {...item} />;
                        })}
                    {errorMessage &&
                        errorMessage.map((error: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{error}</React.Fragment>;
                        })}
                    {buttons &&
                        buttons.map((button: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{button}</React.Fragment>;
                        })}
                    {disclaimer}
                </Node>
            </Node>
        </Module>
    );
};

export default BusinesSignUpView;
